import Projects from '../components/Projects';


export default function ProjectsPage() {
        document.title = "Projects - IGSOSA";
    return <Projects isHomepage={false} maxItems={6} />;
}
